/*
 * constants.js
 *
 * Static lookup tables and tab definitions. Sinds 2026-06-20: top-level tabs
 * gecollapsed naar 4 (persoon) / 2 (samen) zodat de mobile bottom-nav rustig
 * blijft. Vast/Variabel/Extra leven nu als sub-tabs binnen "Uitgaven".
 */

export const MONTHS = [
  'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni',
  'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'
];

// Categorie-data is naar state.S.cats verhuisd (CRUD-baar — punt 5).
// Gebruik catById() / catsForScope() uit helpers.js voor lookups.

// Top-level tabs voor de bottom-nav (mobile) en sidebar (desktop).
// `icon` = naam in icons.js. `defaultSub` = sub-tab die geladen wordt
// wanneer de gebruiker op deze tab klikt (alleen voor uitgaven).
export const TABS_P = [
  { id: 'dromen',    lbl: 'Dromen',    icon: 'target' },
  { id: 'home',      lbl: 'Home',      icon: 'home-line' },
  { id: 'inkomsten', lbl: 'Inkomsten', icon: 'wallet-in' },
  { id: 'uitgaven',  lbl: 'Uitgaven',  icon: 'wallet-out', defaultSub: 'extra' }
];

export const TABS_S = [
  { id: 'overzicht', lbl: 'Overzicht', icon: 'home-line' },
  { id: 'uitgaven',  lbl: 'Uitgaven',  icon: 'wallet-out', defaultSub: 'svast' }
];

// Sub-tabs binnen de Uitgaven-tab. Verschillend per persoon-modus omdat
// Samen geen "Extra kosten" heeft (extras zijn persoonlijk).
export const SUBTABS_P = [
  { id: 'extra',    lbl: 'Extra' },
  { id: 'vast',     lbl: 'Vaste' },
  { id: 'variabel', lbl: 'Variabele' }
];

export const SUBTABS_S = [
  { id: 'svast', lbl: 'Vaste' },
  { id: 'svar',  lbl: 'Variabele' }
];
